/**
 * Cheelee Public API Docs
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CurrencyPairItem {
    quotation?: number;
    base_currency?: string;
    quote_currency?: string;
}

